import Form from 'src/utils/Form.js'

class BankAccount extends Form {
  constructor(data, config = null) {
    super(data, config || Form.config)
  }

  destroy(then) {
    return super.delete(`bank-accounts/${this.id}`).then(then)
  }

  update(then) {
    return super.patch(`bank-accounts/${this.id}`).then(then)
  }
}

export default BankAccount
